const WorkExperience = [
    {
        id: 1,
        title: "Full Stack Developer & Instructor",
        company: "Code213",
        yearsActive: "2023 - Present",
        information: [
            "Teaching and mentoring students in computer science and software development.",
            "Developed web and mobile applications using modern technologies such as React, Node.js, and MongoDB.",
        ],
    },
    {
        id: 2,
        title: "Full Stack Developer",
        company: "Binnovant",
        yearsActive: "2022 - Present",
        information: [
            "Developed and optimized multiple landing pages and platforms for clients.",
            "Worked closely with clients to gather requirements and deliver tailored tech solutions.",
            "Utilized technologies like TypeScript, Next.js, and Laravel to create user-centric products.",
        ],
    },
    {
        id: 3,
        title: "Front-End Developer",
        company: "MyServx",
        yearsActive: "2021 - 2022",
        information: [
            "Designed and implemented intuitive and responsive user interfaces using React.",
            "Collaborated with back-end developers to ensure smooth integration of APIs.",
            "Created reusable components to ensure design consistency across the application.",
        ],
    },
    {
        id: 4,
        title: "Developer",
        company: "Atlass Marketplace",
        yearsActive: "2020 - 2021",
        information: [
            "Developed and maintained e-commerce solutions and dashboards.",
            "Worked on optimizing performance and ensuring cross-browser compatibility.",
        ],
    },
    {
        id: 5,
        title: "Hackathon Participant & Team Leader",
        company: "Ctrl-Alt-Code",
        yearsActive: "2021",
        information: [
            "Led a team that developed educational platforms and AI models for teaching and learning.",
            "Won the top spot in Junction X Algiers Hackathon and other hackathons like HackUPC in Spain.",
        ],
    },
];

export default WorkExperience;
